import { CardsSectionContainer } from "shared/components/CardsSection";
import { CenteredContentSectionContainer } from "shared/components/CenteredContentSection";
import { HomeHero } from "clariah/components/HomeHero";
import { HomeLandingPageSection } from "shared/components/HomeLandingPageSection";
import { LogoSectionContainer } from "shared/components/LogoSection";
import { NewsletterSection } from "shared/components/NewsletterSection";
import { OffsetImageWithContentSection } from "shared/components/OffsetImageWithContentSection";
import { Page } from "clariah/components/Page";
import { QuoteSectionContainer } from "shared/components/QuoteSection";
import { useAppContext } from "shared/utils/useAppContext";

export const HomePage = ({
  about,
  aboutResources,
  cards,
  footer,
  hero,
  ineo,
  mirrorPath,
  navigation,
  partners,
  quote,
  seo,
}) => {
  const { scope } = useAppContext();

  return (
    <Page
      darkHeader
      description={seo?.description}
      footer={footer}
      image={seo?.image}
      mirrorPath={mirrorPath}
      navigation={navigation}
      title={[seo?.title || scope, hero?.intro].join(" - ")}
    >
      <HomeHero {...hero} />
      <CenteredContentSectionContainer
        title={about?.title}
        body={about?.intro}
      />
      {(about?.sections || []).map((section, i) => (
        <HomeLandingPageSection
          key={section.title}
          {...section}
          reversed={i % 2 === 1}
        />
      ))}
      {quote && <QuoteSectionContainer {...quote} hasBorderbottom={false} />}
      {ineo && <OffsetImageWithContentSection {...ineo} />}
      {aboutResources && (
        <CenteredContentSectionContainer {...aboutResources} />
      )}
      {cards && (
        <CardsSectionContainer items={cards?.items} title={cards?.title} />
      )}
      <NewsletterSection />
      {partners && <LogoSectionContainer {...partners} hasBorderBottom />}
    </Page>
  );
};
